/* pi-scrolling-text.js — horizontal infinite marquee ==================== */
(function () {
  if (window.customElements.get('pi-scrolling-text-line')) return;

  const debounce =
    window.PiUtils?.debounce ||
    function (fn, wait) {
      let timer;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, arguments), wait);
      };
    };

  /**
   * Duplicates a message item inside a horizontal track until it fills
   * twice the viewport, then animates the track by -50% for a seamless loop.
   */
  class PiScrollingTextLine extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-pi-st-viewport]');
      this.track = this.querySelector('[data-pi-st-track]');
      this.template = this.querySelector('[data-pi-st-item]');

      if (!this.viewport || !this.track || !this.template) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.createItem = () => this.template.content.firstElementChild.cloneNode(true);

      this.build = this.build.bind(this);
      this.onResize = debounce(this.build, 120);

      this.build();

      if (!this.reducedMotion) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.viewport);
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    measureItemWidth() {
      const probe = this.createItem();
      probe.style.position = 'absolute';
      probe.style.visibility = 'hidden';
      probe.style.pointerEvents = 'none';

      this.viewport.appendChild(probe);
      const width = probe.getBoundingClientRect().width;
      probe.remove();

      return width;
    }

    cloneCount(viewportWidth, itemWidth) {
      if (!itemWidth) return 2;

      let count = Math.ceil((viewportWidth * 2) / itemWidth);
      count = Math.max(2, count);
      if (count % 2 !== 0) count += 1;

      return count;
    }

    build() {
      const viewportWidth = this.viewport.clientWidth;
      if (!viewportWidth) {
        requestAnimationFrame(this.build);
        return;
      }

      const itemWidth = this.measureItemWidth();
      const perSet = this.cloneCount(viewportWidth, itemWidth) / 2;

      this.track.replaceChildren();

      for (let set = 0; set < 2; set++) {
        for (let i = 0; i < perSet; i++) {
          this.track.appendChild(this.createItem());
        }
      }

      this.setAttribute('data-ready', 'true');
    }
  }

  window.customElements.define('pi-scrolling-text-line', PiScrollingTextLine);
})();
